/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmployeesEmployeesEmployee } from './employees-employees-employee';
import { TalentRecommendationApproval } from './talent-recommendation-approval';
import { TalentPoolLight } from './talent-pool-light';

export interface TalentRecommendation {
  id: string;
  employeeId: string;
  talentPoolId: string;
  recommendationState: TalentRecommendationRecommendationStateEnum;
  reasonForRecommendation: string | null;
  careerAspirations?: string | null;
  approvals: Array<TalentRecommendationApproval> | null;
  state: TalentRecommendationStateEnum;
  createdById: string;
  createdAt: string;
  updatedById: string;
  updatedAt: string;
  talentPool?: TalentPoolLight;
  createdBy?: EmployeesEmployeesEmployee;
  updatedBy?: EmployeesEmployeesEmployee;
  isWildcardCandidate?: boolean;
  recommendationReviewNotes?: string | null;
}
export enum TalentRecommendationRecommendationStateEnum {
  Recommended = 'Recommended',
  ReviewerAccepted = 'ReviewerAccepted',
  ReviewerDeclined = 'ReviewerDeclined',
  Approved = 'Approved',
  Declined = 'Declined'
}
export enum TalentRecommendationStateEnum {
  Open = 'Open',
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected'
}
